export const GATED_BIBLIOGRAPHY_MODAL = 'gated-bibliography-modal'
export const GATED_BIBLIOGRAPHY_MODAL_HEADER = 'gated-bibliography-modal-header'
export const GATED_BIBLIOGRAPHY_MODAL_MESSAGE = 'gated-bibliography-modal-message'
export const GATED_BIBLIOGRAPHY_MODAL_UPGRADE_BUTTON =
  'gated-bibliography-modal-upgrade-btn'
export const GATED_BIBLIOGRAPHY_MODAL_CONTINUE_BUTTON =
  'gated-bibliography-modal-continue-btn'
